export class Job {
    id: string;
    name: string;
    // password: string;
    // email: string;
    // lang: string;
    // branch_id: string;
    status: string;
    // telephone: string;
    // address: string;
    // fax: string;

    constructor(id: string, name: string, status: string) {
        this.id = id;
        this.name = name;
        this.status = status;
        // this.password = password;
        // this.email = email;
        // this.lang = lang;
        // this.branch_id = branch_id;
        // this.status = status;
        // this.fax = fax;
        // this.telephone = telephone;
        // this.address = address;
    }
}



// WEBPACK FOOTER //
// ./src/app/model/job.ts